// extracted by mini-css-extract-plugin
module.exports = {"alert":"style_alert__3f8_E"};